import { render } from "./ManagementLayout.vue?vue&type=template&id=76766885"
import script from "./ManagementLayout.vue?vue&type=script&lang=ts"
export * from "./ManagementLayout.vue?vue&type=script&lang=ts"

import "./ManagementLayout.vue?vue&type=style&index=0&id=76766885&lang=scss"
script.render = render

export default script